import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        style: {
            fill: "none"
        }
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.5083 9.34961V13.0913C2.5083 16.8329 4.0083 18.3329 7.74997 18.3329H12.2416C15.9833 18.3329 17.4833 16.8329 17.4833 13.0913V9.34961",
                stroke: "#FF592C",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.99975 10.0003C11.5247 10.0003 12.6497 8.75866 12.4997 7.23366L11.9497 1.66699H8.05808L7.49975 7.23366C7.34975 8.75866 8.47475 10.0003 9.99975 10.0003Z",
                stroke: "#FF592C",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.2582 10.0003C16.9415 10.0003 18.1748 8.63366 18.0082 6.95866L17.7748 4.66699C17.4748 2.50033 16.6415 1.66699 14.4582 1.66699H11.9165L12.4998 7.50866C12.6415 8.88366 13.8832 10.0003 15.2582 10.0003Z",
                stroke: "#FF592C",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.69966 10.0003C6.07466 10.0003 7.31632 8.88366 7.44966 7.50866L7.63299 5.66699L8.03299 1.66699H5.49133C3.30799 1.66699 2.47466 2.50033 2.17466 4.66699L1.94966 6.95866C1.78299 8.63366 3.01632 10.0003 4.69966 10.0003Z",
                stroke: "#FF592C",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.99984 14.167C8.60817 14.167 7.9165 14.8587 7.9165 16.2503V18.3337H12.0832V16.2503C12.0832 14.8587 11.3915 14.167 9.99984 14.167Z",
                stroke: "#FF592C",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
export default Icon;
